import styled from 'styled-components';

export const ShellWrapper = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
`;

export const TopBar = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => `0 ${theme.spaces.space5} ${theme.spaces.space4}`};

  @media (min-width: 769px) {
    padding-top: 40px;
  }
`;
